export default __webpack_public_path__ + "static/media/SWT1630.34I-38572_-22588_0.009b9617.jpg";